import * as React from 'react';
import careStore from "../../store/careStore";
import {relative} from 'path';
import * as util from "../../utils/util";

import CareInfo from './CareInfo';
import CareHealth from './CareHealth';
import CareActivity from './CareActivity';
import CareLose from './CareLose';
import CareRate from './CareRate';
import CareMenu from './CareMenu';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {useTheme} from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Stack from '@mui/material/Stack';
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

const steps = ['', '', '', '', ''];

const ReservationStep = () => {
  const navigate = useNavigate();
  const storeData: any = careStore();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});
  
  useEffect(() => {
    
    return () => {
    }
  }, []);

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    
    if(activeStep === 0){
      if(util.strNull(storeData.careInfo.height) === '' || util.strNull(storeData.careInfo.height) < 50 || util.strNull(storeData.careInfo.height) > 250){
        alert('신장을 정상적으로 입력해주세요.');
        return false;
      }else if (util.strNull(storeData.careInfo.weight) === '' || util.strNull(storeData.careInfo.weight) < 10 || util.strNull(storeData.careInfo.weight) > 300){
        alert('체중을 정상적으로 입력해주세요.');
        return false;
      }
    }
    
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };
  
  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  
  const drawStepContent = (activeStep:number) => {
    if(activeStep === 0){
      return (
        <CareInfo />
      )
    }else if(activeStep === 1){
      return (
        <CareHealth />
      )
    }else if(activeStep === 2){
      return (
        <CareActivity />
      )
    }else if(activeStep === 3){
      return (
        <CareLose />
      )
    }
    else if(activeStep === 4){
      return (
        <CareRate />
      )
    }
    else if(activeStep === 5){
      navigate('/care/CareMenu');
    }
  };


  return (
    <Stack  sx={{ width: '100%',minWidth:320, background:'#F1F2F4'}} spacing={2}>
      <Top title="케 어" />
        <Box sx={{position:'relative'}}>

 
          <Stepper alternativeLabel  activeStep={activeStep} sx={{mb:2}}>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
              );
            })}
          </Stepper>
          
          <div>
            {allStepsCompleted() ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                </Typography>
              </React.Fragment>
            ) : (
              drawStepContent(activeStep)
            )}
          </div>
          
          <MobileStepper
            variant="progress"
            steps={steps.length+1}
            position="static"
            activeStep={activeStep}

            sx={{ width: '100%',  flexGrow: 1,  p:'0 20px 0px 20px', mb:10, mt:3, bgcolor:'#eeeff1', boxSizing:'border-box', 
              '& .MuiLinearProgress-root' : {display:'none'}
            }}
            nextButton={
              <Button size="small" onClick={handleNext} disabled={activeStep === 6} sx={stepNextBtn}>
                Next
                {theme.direction === 'rtl' ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight />
                )}
              </Button>
            }
            backButton={
              <Button size="small" onClick={handleBack} disabled={activeStep === 0} sx={stepNextBtn}>
                {theme.direction === 'rtl' ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
                Back
              </Button>
            }
          />
        </Box>
      <Bottom />
    </Stack >
  );
}

const stepNextBtn = {
  bgcolor: '#fff',
  color: '#ef8322',
  borderRadius:'30px',
  border:'1px solid #ef8322',
  width:'48%',
  p:'10px',
  '& .MuiButtonBase-root:hover' :{
    bgcolor:'#ef8322 !important',
    color:'#fff'
  }


}

export default ReservationStep;